<template>

    <h2>Študijný plán</h2>
        <v-row align="center" style="margin:1px">
            <v-spacer />
            <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 0">Prehľad</v-btn>
            <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 1">Zoznam</v-btn>
        </v-row> 

        <v-card-text v-if="toggle_select==0 && myRozpisBc.length > 0">
            <h3 style="margin:5px">1. stupeň (bc.)</h3>
            <table border="1" style="padding:0px;spacing:0px;border-collapse: collapse;">
                <tr>
                  <td align="center"><b>sem.</b></td>  
                  <td v-for="oblast, index2 in myPlan.oblasti" :key="index2" valign="center" align="center" :style="getBackgroundOblasti(index2)" width="10.7%">
                    <span style="margin:5px">
                    <b>{{oblast.oblast}}</b>
                    </span>
                  </td>
                </tr>
                <tr v-for="semester, index in myRozpisBc" :key="index">
                    <td align="center">{{index+1}}.</td>
                    <td v-for="oblast, index2 in semester.oblasti" :key="index2" valign="top"  :style="getBackgroundOblasti(index2)">
                        <v-card variant="outlined" v-for="predmet, index3 in oblast.predmety" :key="index3" :style="getForegroundOblasti(index2)"
                                @click="otvorInfolist(predmet.skratka)">
                            <v-card-text style="margin:-5px">
                                {{predmet.nazov}}
                                <v-icon class="btn-close" style="color:#2E7D32" v-if="predmet.typ=='PP'" size="14px" title="PP">star</v-icon>
                                <v-icon class="btn-close" style="color:#2E7D32" v-if="predmet.typ=='PVP'" size="14px" title="PVP">star_half</v-icon>
                            </v-card-text>
                        </v-card>
                    </td>
                </tr>
            </table>
        </v-card-text>

        <v-card-text v-if="toggle_select==0 && myRozpisMgr.length > 0">
            <h3 style="margin:5px">2. stupeň (Mgr.)</h3>
            <table border="1" style="padding:0px;spacing:0px;border-collapse: collapse;">
                <tr>
                  <td align="center"><b>sem.</b></td>  
                  <td v-for="oblast, index2 in myPlan.oblasti" :key="index2" valign="center" align="center" :style="getBackgroundOblasti(index2)" width="10.7%">
                    <span style="margin:5px">
                    <b>{{oblast.oblast}}</b>
                    </span>
                  </td>
                </tr>
                <tr v-for="semester, index in myRozpisMgr" :key="index">
                    <td align="center">{{index+1}}.</td>
                    <td v-for="oblast, index2 in semester.oblasti" :key="index2" valign="top"  :style="getBackgroundOblasti(index2)">
                        <v-card variant="outlined" v-for="predmet, index3 in oblast.predmety" :key="index3" :style="getForegroundOblasti(index2)"
                            @click="otvorInfolist(predmet.skratka)">
                            <v-card-text style="margin:-5px">
                                {{predmet.nazov}}
                                <v-icon class="btn-close" style="color:#2E7D32" v-if="predmet.typ=='PP'" size="14px" title="PP">star</v-icon>
                                <v-icon class="btn-close" style="color:#2E7D32" v-if="predmet.typ=='PVP'" size="14px" title="PVP">star_half</v-icon>
                            </v-card-text>
                        </v-card>
                    </td>
                </tr>
            </table>
        </v-card-text>
        <v-card-text v-if="toggle_select==0">
            <p><v-icon style="color:#2E7D32" size="15px" >star</v-icon> - povinné predmety</p>
            <p><v-icon style="color:#2E7D32" size="15px" >star_half</v-icon> - povinne voliteľné predmety</p>
        </v-card-text>

        <v-card-text v-if="toggle_select==1 && myPlan">
            <table border="1" style="padding:0px;spacing:0px;border-collapse: collapse;width:100%">
                <tr>
                    <th style="padding:5px">skratka</th>
                    <th style="padding:5px"> názov </th>
                    <th style="padding:5px"> typ </th>
                    <th style="padding:5px"> ročník </th>
                    <th style="padding:5px"> semester </th>
                    <th style="padding:5px"> kredity </th>
                    <th style="padding:5px"> rozsah </th>
                    <th style="padding:5px"> spôsob ukončenia </th>
                </tr>
                <tr style="background-color:#2E7D32;color:white;padding:5px">
                    <td style="background-color:#2E7D32;color:white;padding:5px;" colspan="8">1. stupeň (bc.)</td></tr>
                <tr v-for="predmet,index in myPlan.predmety_bc" :key="index" :style="getPredmetStyle(predmet)" @click="otvorInfolist(predmet.skratka)">                    
                    <td style="padding:5px">{{predmet.skratka}} &nbsp;&nbsp;</td>
                    <td style="padding:5px">{{predmet.nazov}} &nbsp;&nbsp;</td>
                    <td align="center">{{predmet.typ}}</td>
                    <td align="center">{{predmet.rocnik}}</td>
                    <td align="center">{{predmet.semester}}</td>
                    <td align="center">{{predmet.kredity}}</td>
                    <td align="center"><span v-if="predmet.prednasky > 0">{{predmet.prednasky}}P
                        </span> 
                        <span v-if="predmet.prednasky > 0 && predmet.seminare > 0"> + </span>
                        <span v-if="predmet.seminare > 0">{{predmet.seminare}}C</span>
                    </td>
                    <td align="center">{{predmet.ukoncenie}}</td>
                </tr>
                <tr style="background-color:#2E7D32;color:white;padding:5px">
                    <td style="background-color:#2E7D32;color:white;padding:5px;" colspan="8">2. stupeň (Mgr.)</td></tr>
                <tr v-for="predmet,index in myPlan.predmety_mgr" :key="index" :style="getPredmetStyle(predmet)" @click="otvorInfolist(predmet.skratka)">
                    <td style="padding:5px">{{predmet.skratka}}</td>
                    <td style="padding:5px">{{predmet.nazov}}</td>
                    <td align="center">{{predmet.typ}}</td>
                    <td align="center">{{predmet.rocnik}}</td>
                    <td align="center">{{predmet.semester}}</td>
                    <td align="center">{{predmet.kredity}}</td>
                    <td align="center"><span v-if="predmet.prednasky > 0">{{predmet.prednasky}}P
                        </span> 
                        <span v-if="predmet.prednasky > 0 && predmet.seminare > 0"> + </span>
                        <span v-if="predmet.seminare > 0">{{predmet.seminare}}C</span>
                    </td>
                    <td align="center">{{predmet.ukoncenie}}</td>
                </tr>
            </table>
        </v-card-text>
    
</template>


<script>
import axios from '../../axios-auth.js'
// import { xml2json } from 'xml-js';


export default {
    data() {
        return {
            myPlan : null,
            prechod: 0,
            myRozpisBc: [],
            myRozpisMgr: [],
            toggle_select: 0
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.prepareData()
        },
        prepareData() {
            axios.get('/get-study-plan', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myPlan = res.data
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                this.myRozpisBc = this.makeRozpis(this.myPlan.predmety_bc,6)
                this.myRozpisMgr = this.makeRozpis(this.myPlan.predmety_mgr,4)
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        makeRozpis(_predmety, _pocet_semestrov) {
            const _psemestre = []
            for(let i = 1; i <= _pocet_semestrov; i++) { // semestre
                const _poblasti = []
                for(let j = 0; j < this.myPlan.oblasti.length; j++) { // oblasti
                    const _plist = []
                    for(let k = 0; k < _predmety.length; k++) {
                        if (_predmety[k].semester == i && _predmety[k].oblast_id == this.myPlan.oblasti[j].id) {
                            _plist.push({skratka: _predmety[k].skratka, nazov: _predmety[k].nazov, typ: _predmety[k].typ})
                        }
                    }
                    _poblasti.push({id: j, predmety: _plist})
                }
                _psemestre.push({semester:i, oblasti: _poblasti})
            }
        return _psemestre
        },
        getPredmetStyle(_predmet) {
            var _st = 'cursor:pointer;'
            if (_predmet.typ=="PP") {
                _st = _st + 'font-weight: bold;'
            }
            if (_predmet.semester % 2 == 0) {
                _st = _st + 'background-color: #E8F5E9;'
            }
            return _st
        },
        getBackgroundOblasti(_index) {
            return "background-color:" + this.myPlan.oblasti[_index].color1
        },
        getForegroundOblasti(_index) {
            return "margin:2px;background-color:" + this.myPlan.oblasti[_index].color2
        },
        otvorInfolist(_predmet) {
            const _name = this.$route.name
            this.$router.push({name:_name=='study_plan'?'infor_list':'info_list', params: { id: this.pripravSkratkuPredmetu(_predmet)}})
        },
        pripravSkratkuPredmetu(_predmet) {
            return _predmet.replaceAll('/','-')
        }

    }
}
</script>

